import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import { isLastListItem } from '../../../utils/common'
import { Divider } from '../../Divider'
import { Status } from '../../Status'
import Text from '../../Text'

import { SETTINGS_STATUS_TONE_COLORS } from './SettingsStatus.constants'

import * as styles from './SettingsStatus.module.css'

function SettingsStatus({ children, items }) {
  const { t } = useTranslation()

  return (
    <div className={styles.SettingsStatus}>
      {items.map(({ after, labelKey, tone, value }, index) => (
        <Fragment key={labelKey}>
          <div className={styles.item}>
            <Text isSecondary>{t(labelKey)}</Text>
            <div className={styles.value}>
              {tone ? (
                <Status {...SETTINGS_STATUS_TONE_COLORS[tone]} text={value} />
              ) : (
                <Text>{value}</Text>
              )}
              {after}
            </div>
          </div>
          {isLastListItem(items.length, index) ? null : (
            <Divider className={styles.divider} />
          )}
        </Fragment>
      ))}
      {children}
    </div>
  )
}

export default SettingsStatus
